<template>
  <div style="height: calc(100vh - 195px);overflow: auto;padding-right:8px">
    <div style="padding-top:10px;">
      <div>
        <el-row :gutter="10">
          <el-col :span="12" >
            <el-card class="card" style="padding:0 5px;border: 1px solid #C5D0E2;" shadow="hover">
              <div class="content"  >
                
                    <div class="title" style="margin:5px 0;">
                          <span  style="font-size: 1.0rem;font-weight:bold;">{{ $t('failure.failureTotal') }}：{{total}}</span>
                          <span style="margin-left: 30px;font-size: 0.95rem;">
                            <i class="iconfont icon-icon_prompt2" style="font-size: 18px;color: #5470c6;"></i>
                            {{rank1}}
                          </span>
                          <span style="margin-left: 30px;font-size: 0.95rem;">
                            <i class="iconfont icon-icon_prompt2" style="font-size: 18px;color: rgb(221, 190, 16);"></i>
                            {{rank2}}
                          </span>

                          <span style="margin-left: 30px;font-size: 0.95rem;">
                            <i class="iconfont icon-icon_prompt2" style="font-size: 18px;color: #FF8C00;"></i>
                            {{rank3}}
                          </span>
                          <span style="margin-left: 30px;font-size: 0.95rem;">
                            <i class="iconfont icon-icon_prompt2" style="font-size: 18px;color: #cd1f25"></i>
                            {{rank4}}
                          </span>
                          <span style="font-size: 0.95rem;">
                            {{$t("failure.newTime")}}：{{today}}
                            <i class="el-icon-refresh" style="cursor: pointer;color:#5b8ddd;margin-left:8px;font-size:20px;text-align:right" @click="getData(1)"></i>
                          </span>
                          
                      </div>
                    <div >
                    <el-table
                      v-loading="loading"
                      :data="alarmlist"  
                      border
                      height="418" 
                      :size="size" 
                      style="width: 100%;"
                      highlight-current-row 
                      @current-change="Location"
                      tooltip-effect="light"
                    >
                        <el-table-column prop="id" :label="$t('public.OrderIndex')" width="45" align="center"></el-table-column>
                        <el-table-column prop="Group" :label="this.$t('failure.group')" width="100" align="center"></el-table-column>
                        <el-table-column prop="CarNo" :label="$t('failure.carNo')" width="100" align="center"></el-table-column>
                        <el-table-column prop="VehicleModel" :label="$t('failure.vehicleModel')" width="105" align="center"> </el-table-column>
                        <el-table-column prop="FailureTimec" :label="$t('failure.故障时间')" width="100" align="center"> </el-table-column>
                        <el-table-column prop="FailureType" :label="$t('failure.故障类型')" width="100" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Failure" :label="$t('failure.故障描述')" align="center"></el-table-column>
                        <!-- <el-table-column  prop="export" :label="$t('failure.车辆位置')" width="85" align="center">
                            <template  slot-scope="scope">
                              <el-button :disabled="!clickFlag(scope.row)" size="mini"  type="text" style="padding:none;" @click="Location(scope.row)" >{{ $t('failure.location2') }}</el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>
                    
                    <div style="text-align: right ;margin-top:5px" class="pagination"  >
                      <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="pageSize"
                        layout="total,prev, pager, next"
                        :total="total">
                      </el-pagination>
                    </div>
                  </div>

              </div>
            </el-card>

          </el-col>
          <el-col :span="12">
            <el-card class="card" style="padding:0 8px;border: 1px solid #C5D0E2;" shadow="hover">
              <div style="float:left;border-radius: 4px;width:100%">
                  <KingLongMap ref="map" mapId="klmap_failureStats" style="height: 498px;width:100%" />
              </div>
            </el-card>

          </el-col>
        </el-row>
      </div>

    </div>
    <div style="display: flex;justify-content: right;margin-top:8px">
      <el-row>
        <div>
            <el-form :inline="true" class="form"  style="text-align: left;" ref="form" :model="form">
            <el-form-item >
                <el-radio-group  v-model="form.radio"  :size="size" @change="search(1)">
                  <el-radio-button :label="lastMonth"  ></el-radio-button>
                  <el-radio-button :label="thisMonth"  ></el-radio-button>
                  <el-radio-button :label="lastWeek"  ></el-radio-button>
                  <el-radio-button :label="yesterday" ></el-radio-button>
                  <el-radio-button :label="tadayButton" ></el-radio-button>
                  <el-radio-button :label="custom" ></el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-form-item v-show="showTimePiker">
                <el-date-picker :size="size" style="width:302px"
                
                  v-model="form.time1"
                  type="daterange"
                  :range-separator="to"
                  :start-placeholder="chooseStartTime"
                  :end-placeholder="chooseEndTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :clearable="false"
                  :picker-options="datePickerOptions"
                  >
                </el-date-picker>

            </el-form-item>
            <el-form-item v-show="showTimePiker">
                <el-button  :size="size" type="primary" @click="search(2)">{{ $t('public.query') }}</el-button>
            </el-form-item>
            <el-form-item>
                  <el-button :size="size" @click="reset('form')">{{ $t('failure.reset') }}</el-button>
            </el-form-item>
          </el-form>

        </div>
      </el-row>
    </div>

    <!-- <failureChart/> -->
    <div style="padding:10px 0">
      <div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-card class="card border" style="padding:0 8px" shadow="hover">
                <div class="FailureLevel " style="height: 400px;" >
                  <!-- <div style="padding: 10px 10px; " > -->
                      <span  style="font-size: 1.0rem;font-weight:bold;">{{ $t('failure.faultProportion') }}</span>
                      <div  v-loading="loadingPie">
                        <div style="text-align:center" >
                            <div id="chart_alarmPro" v-show="pieShow" :data="piedata" style="width: 100%;height: 350px;margin-top:10px;"></div>
                        </div>
                        <div class="nomessage" style="text-align:center;" v-show="!pieShow" >
                          <span style="font-size: 23px;margin-left: 30px;color: #777;">
                            <i class="iconfont icon-icon_prompt2" style="font-size: 20px;margin-right: 4px;"></i>
                            {{ $t('failure.nomessage') }}
                          </span>
                        </div>
                      </div>
                </div>
            </el-card>
          </el-col>
            <el-col :span="12">
            <el-card class="card border" style="padding:0 8px" shadow="hover">
                <div class="VehicleFault " style="height: 400px;">

                    <span  style="font-size: 1.0rem; font-weight:bold;">{{ $t('failure.faultVelRank') }}</span>
                    <div v-loading="loadingRank">

                      <div style="text-align:center">
                        <div id="chart_rank" v-show="RankShow" :data="Rankdata" style="width: 100%;height: 383px;"></div>
                      </div>
                      <div class="nomessage" style="text-align:center;" v-show="!RankShow" >
                          <span style="font-size: 23px;margin-left: 30px;color: #777;">
                            <i class="iconfont icon-icon_prompt2" style="font-size: 20px;margin-right: 4px;"></i>
                            {{ $t('failure.nomessage') }}
                          </span>

                      </div>
                    </div>

                </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>




import KingLongMap from "@/components/KingLongMap"
import { mapState } from 'vuex'
// import * as echarts from 'echarts'
import language from '@/utils/getLanguageId'

export default {

    components: {
        KingLongMap
    },

    data(){
      return{
        loadingRank:false,
        loadingPie:false,
        today:"",
        datePickerOptions: {
          disabledDate(date) {
              return date > new Date(new Date().getTime() )
          }
        },
        showTimePiker:true,
        paginationShow:false,
        form:{
            radio:this.$t('failure.custom'),
            time1:[this.moment(new Date(new Date().getTime()-3600*1000*24*6)).format('YYYY-MM-DD'), this.moment(new Date().getTime()).format('YYYY-MM-DD')],
        },
       
        startTime:'',
        endTime:'',
        alarmlist: [],
       
        // 分页
        total:0,
        currentPage:1,
        pageSize:10,

        rank1:0,
        rank2:0,
        rank3:0,
        rank4:0,
        Latitude:'',
        Longitude:'',
        vehicles:"",
        marker:'',
        label:'',

        loading: false,
        // listShow:false,
        
        chart_alarmPro:undefined,
        chart_rank:undefined,
        piedata:[],
        Rankdata:[],
        
        Ranknum:[],
        vel:[],
        
        
        chooseStartTime:this.$t('time.startTime'),
        chooseEndTime:this.$t('time.endTime'),
        to:this.$t('time.to'),
        thisMonth:this.$t('time.thisMonth'),
        lastWeek:this.$t('time.lastWeek'),
        yesterday:this.$t('time.yesterday'),
        lastMonth:this.$t('time.lastMonth'),
        tadayButton:this.$t('time.today'),
        custom:this.$t('failure.custom'),
        pieShow:false,
        RankShow:false,
        LanguageId:1,
      };

    },
   
    computed:{

      size() {
        return this.$store.getters.size
      },
     
      ...mapState({
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
      }),
    },
    mounted() {
      
      this.today = this.moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      this.loading = true;
      this.pieShow=true;
      this.RankShow=true;
      this.LanguageId = language(this.$store.getters.locale)
      this.PieChart();//初始化
      this.BarChart();
      this.search(2);//初始化进去是自定义的查询
      this.getData();
      this.setResize();
      window.addEventListener('resize',this.setResize);
    },
    activated(){
      this.setResize();
      window.addEventListener('resize',this.setResize);
    },
     watch: {
     'form.radio':{
        handler(newval,oldval){
          // this.form.time1=[];
          // console.log(newval);
          if(newval == this.$t('failure.custom')){
            this.showTimePiker = true;
          }else{
            this.showTimePiker = false;
          }
        },
        deep: true
      },
      pieShow(){
        this.$nextTick(function () {
            var myEvent = new Event("resize");
            window.dispatchEvent(myEvent);
          });
        deep: true
      },
      RankShow(){
        this.$nextTick(function () {
            var myEvent = new Event("resize");
            window.dispatchEvent(myEvent);
          });
        deep: true
      },
      
    },

    methods: {
      
        // 时间解析;年月日
      Time:function(now)   {
        let year=new Date(now).getFullYear();
        let month=new Date(now).getMonth()+1;
        let date=new Date(now).getDate();

        if (month < 10) month = "0" + month;
        if (date < 10) date = "0" + date;
        return  year+"-"+month+"-"+date+" "
      },

      //获得某月的天数：
      getMonthDays:function (myMonth){
        let monthStartDate = new Date(new Date().getFullYear(), myMonth, 1);
        let monthEndDate = new Date(new Date().getFullYear(), myMonth + 1, 1);
        let days= (monthEndDate - monthStartDate)/(1000   *   60   *   60   *   24);
        return  days;
      },
      search(val){
        //val  1是非自定义时查询，2是自定义时间查询
          var date = new Date();
          var way=this.form.radio;

          switch (way){

            case this.$t('time.yesterday'):

              this.startTime= this.Time(date.getTime()-24*60*60*1000);
              this.endTime=this.Time(date.getTime()-24*60*60*1000);

              break;
            case this.$t('time.today'):
              this.startTime = this.Time(date.getTime());
              this.endTime = this.Time(date.getTime());
              break;
            case this.$t('time.lastWeek'):
              this.startTime=this.Time(new Date(date.getFullYear(), date.getMonth(), date.getDate()-date.getDay()-6));
              this.endTime=this.Time(new Date(date.getFullYear(), date.getMonth(), date.getDate()+(6-date.getDay()-6)));

              break;
            case this.$t('time.thisMonth'):
              this.startTime=this.Time(new Date(date.getFullYear(), date.getMonth(),1));
              this.endTime=this.Time(date.getTime());
              break;
            case this.$t('time.lastMonth'):
              this.startTime=this.Time(new Date(date.getFullYear(),date.getMonth()-1,1));
              this.endTime=this.Time(new Date(date.getFullYear(),date.getMonth()-1,this.getMonthDays(date.getMonth()-1)));
              break;
            case this.$t('failure.custom'):
              this.startTime=this.form.time1[0];
              this.endTime=this.form.time1[1];
              break;

          }
          console.log(this.startTime,this.endTime);
          // this.clearArr();
          // console.log(val);
          //点击自定义时不进行立即查询，要去点查询按钮
          if(way == this.$t('failure.custom') && val == 2){
            //点击查询按钮的时候进行查询
            this.getPieData(this.startTime,this.endTime)
            this.getRankDate(this.startTime,this.endTime)
          }
          if(way != this.$t('failure.custom') && val == 1){
            //点击非自定义按钮查询
            this.getPieData(this.startTime,this.endTime)
            this.getRankDate(this.startTime,this.endTime)
          }
         
      },
      clickRadio(){
           
            this.search();
        },

      //获取选中的车辆
      getSelectedVehicles(){
        this.vehicles = "";
        for(let k = 0; k < this.selectedVehicles.length; k++){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
        return this.vehicles.substring(0,this.vehicles.length-1);
      },
      //获取表格数据
      getData(isRefresh){
        if(isRefresh){
          this.today = this.moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        }
        let initDate = this.today.split(" ")[0];
        this.loading = true;
        this.piedata.splice(0, this.piedata.length);
        this.Rankdata.splice(0, this.Rankdata.length);
        this.Ranknum.splice(0, this.Ranknum.length);
        this.vehicles = this.getSelectedVehicles();
        //获取表格数据
        this.$api.FailureInfo({
          StartDate: initDate,//startTime,//"2023-09-17",//startTime,
          EndDate: initDate,//endTime,//"2023-09-17",//endTime,
          // vehicles:this.vehicles,
          vehicles:"",//暂定只差全部车辆，后续确认
          OperatorID:this.$store.getters.operator.OperatorId,
          SubjectCorpID: this.$store.getters.operator.CompanyId,
          info:"",
          pageNo:this.currentPage,
          pageSize:this.pageSize,
          Language: this.LanguageId,
          IsExport: 0, // 0是查询 1是下载
        })
        .then((res)=>{
          console.log(res);
          if(res && res.code == 200){
            // console.log("------------");
            this.loading = false;
            this.alarmlist = res.data;
            this.total = res.recordsTotal;
            this.rank1=res.rank1;
            this.rank2=res.rank2;
            this.rank3=res.rank3;
            this.rank4=res.rank4;
          }
          else{
            this.loading = false;
            this.alarmlist=[];
            this.rank1=res.rank1;
            this.rank2=res.rank2;
            this.rank3=res.rank3;
            this.rank4=res.rank4;
            this.total = res.recordsTotal;
            this.currentPage=1;
          }
        }).catch(() => {

            this.loading = false;
            this.alarmlist = []; 
            this.total = 0;
            this.rank1=0;
            this.rank2=0;
            this.rank3=0;
            this.rank4=0;
        });
        
      },
     
       //获取饼图数据
      getPieData(StartDate,EndDate){
        console.log("饼图")
        this.piedata = [];
        this.loadingPie = true;
        this.vehicles = this.getSelectedVehicles();
        this.$api.FailureLevel({
          StartDate:StartDate,
          EndDate:EndDate,
          vehicles:this.vehicles,
          OperatorID:this.$store.getters.operator.OperatorId,
          SubjectCorpID: this.$store.getters.operator.CompanyId,
        })
        .then((res)=>{
          if(res && res.code == 200){
            if(res.data && res.data.length > 0){
              this.loadingPie = false;
              this.pieShow = true;
              var x = [];
              res.data.forEach(element => {
                this.piedata.push({name:element.FaultLevel,value:element.FaultNum})
              });
              this.PieChart();
            }else{
              this.loadingPie = false;
              this.pieShow = false;
              this.piedata = [];
            }
          }
        })
        .catch((e)=>{
          this.loadingPie = false;
          this.pieShow = false;
        })

      },
      

      getRankDate(StartDate,EndDate){
        console.log("柱状图")
        this.loadingRank = true;
        this.vehicles = this.getSelectedVehicles();
        this.$api.FailureRank({
          StartDate:StartDate,
          EndDate:EndDate,
          vehicles:this.vehicles,
          OperatorID:this.$store.getters.operator.OperatorId,
          SubjectCorpID: this.$store.getters.operator.CompanyId,
        })  
        .then((res)=>{
          if(res && res.code == 200){
            
            let yAxis = [];
            let xAxis = [];
            if(res.data && res.data.length > 0){
              res.data.forEach((element)=>{
                yAxis.push(element.CarNo)
                xAxis.push(element.VefaultNum)
              })
              this.vel = yAxis.slice(0,10);
              this.Ranknum = xAxis.slice(0,10);
              this.vel = this.vel.reverse();
              this.Ranknum = this.Ranknum.reverse();
              this.BarChart();
              this.loadingRank = false;
              this.RankShow = true;
            }else{
              this.loadingRank = false;
              this.RankShow = false;
            }
          }
        })
        .catch((e)=>{
          this.loadingRank = false;
          this.RankShow = false;
        })
      },

      handleCurrentChange(val) {
        this.currentPage = val;
        this.getData();
      },
      //车辆位置
      Location(row) {
        this.Latitude = row.Latitude;
        this.Longitude = row.Longitude;
        this.$nextTick(function () {
          if (this.$refs.map) {
            this.$refs.map.clearMarkers();
            this.$refs.map.addMarker(
              "v_1011",
              row.CarNo,
              this.Longitude,
              this.Latitude,
              "assets/svgs/icon_loc_selected_270.svg"
            );
            this.$refs.map.setCenter(this.Longitude, this.Latitude);
          }
        });
      },
      clickFlag(row){
          if(row.Latitude==null||row.Longitude==null){
            return false;
          }
          else return true;
      },

       //  重置
      reset(form){
        this.form={
          radio:this.$t('failure.custom'),
          time1:[this.moment(new Date(new Date().getTime()-3600*1000*24*6)).format('YYYY-MM-DD'), this.moment(new Date().getTime()).format('YYYY-MM-DD')],

        };
        this.search(2);
      },
     
      PieChart(){
        this.chart_alarmPro = echarts.init(document.getElementById('chart_alarmPro'));

        var optionPie= {
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          toolbox: {
              show: true,
              feature: {
                  mark: { show: true },
                  // saveAsImage: { show: true },

                  magicType: {
                      show: true,
                      type: ['pie', 'funnel'],
                      option: {
                          funnel: {
                              x: '25%',
                              width: '45%',
                              funnelAlign: 'left',
                              max: 1548
                          }
                      }
                  },

              }
          },
          series: [
            {
              name: this.$t('failure.faultProportion'),
              type: 'pie',
              radius: '80%',
              data: this.piedata,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              itemStyle: {
                normal: {
                  color: function (colors) {
                    var colorList = [
                       '#5470c6',
                      'rgb(221, 190, 16)',
                      '#FF8C00',
                      '#b6373c',
                    ];
                    return colorList[colors.dataIndex];
                  }
                },
              }

            }
          ],

        };
        this.chart_alarmPro.setOption(optionPie, true)

      },
      BarChart(){
        this.chart_rank = echarts.init(document.getElementById('chart_rank'));
        var optionBar= {
          title:{},
          legend: {

          },
          grid: {
            left: '3%',
            right: '13%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
              show: true,
              feature: {
                  saveAsImage: { show: true ,color:'#5b92e5'}

              }
          },
          xAxis: {
            minInterval:1,
            name:this.$t('failure.faultNum'),
            type: 'value',
            splitLine: {
                show: false
            },
            boundaryGap: [0, 0.01]
          },
          yAxis: {
            name:this.$t('failure.vehicle'),
            type: 'category',
            data: this.vel,
          },
          toolbox: {
              show: true,
              feature: {
                  saveAsImage: { show: true }
              }
          },
          series: [

            {

              type: 'bar',
              barWidth:15,
              itemStyle:{
                normal:{
                  color:'#2A7AFF'
                  // #5b92e5
                }
              },
              data:this.Ranknum,
              label:{
                show:true,
                position: 'right', // 标签位置

              }
            }
          ]

        };

        this.chart_rank.setOption(optionBar, true);

      },
      setResize(){
        this.chart_rank.resize();
        this.chart_alarmPro.resize();
      },
  
  },
  destroyed() {
    window.removeEventListener('resize', this.setResize)
  },
  deactivated(){
    window.removeEventListener('resize', this.setResize)
  },
}
</script>

<style lang="scss" scoped>
.el-card {
  background-color: transparent;
}
.el-table {
  background-color: transparent;
}

.header{
  padding: 10px 10px;
}


.border{
  border: 1px solid #C5D0E2;
  border-radius: 4px;
}

.item {
  display:flex;
  justify-content:flex-end;

  height: 2.8rem;
  border-bottom: 1px solid #C5D0E2;


}

.nomessage{
  text-align: center;
  line-height: 400px;

}
.pagination {
  ::v-deep .el-pagination button:disabled,.el-pager li,.el-pagination .btn-prev, .el-pagination .btn-next{
    background-color: transparent !important;
  }

}
.form  {
  ::v-deep .el-form-item {
      margin-bottom: 0px !important;
  }
  ::v-deep .el-form-item__label{
    font-size: 12px;
  }

}
.title span:last-child {
  display: inline-flex;
  float: right; /* 将最后一个元素浮动到右侧 */
  align-items: center;
}
 ::v-deep {
  .el-date-editor .el-range-separator{
    width: 10% !important;
  }
}
</style>